import SmartToyIcon from '@mui/icons-material/SmartToy';
import { SvgIconOwnProps } from '@mui/material';

export default function MadeByAutoTrackerIcon(props: SvgIconOwnProps) {
  return <SmartToyIcon fontSize="small" width="18" height="10" sx={{ color: '#707070' }} {...props} />;
}
